










import Vue from 'vue';
import { AsyncBtn, notify } from 'mycorems-app-shared';
import isGranted from '../auth/isGranted';
import { markAsPrimary } from './payment-method';

interface Data {
  task: Promise<void>|null,
}

export default Vue.extend({
  components: { AsyncBtn },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
    };
  },
  methods: {
    markAsPrimary() {
      this.task = markAsPrimary(this.id);
      this.task.then(() => {
        this.$emit('marked-primary');
        notify.success('Payment method marked as primary.');
      });
    },
    isGranted,
  },
});
